import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import { GetActionableObjectsRequest, IGetActionableObjectsResult } from '../ServerApi/requests/GetActionableObjectsRequest';
import { ITypedIds } from '../ServerApi/types/ITypedIds';
import { ServerService } from './ServerService';

// TODO: in the future, this class and the underlying API will support more action types than editPermissions
//       see http://mytableau/display/devft/getActionableObjects for details
export class GetActionableObjectsForAction {

  public static $inject = ['ServerService'];

  constructor(private server: ServerService) {}

  public editPermissions(ids: ITypedIds): ng.IPromise<IGetActionableObjectsResult> {
    return this.server.sendRequests(
      RequestHelper.buildRequests(ids.ids,
        (idsBlock) => new GetActionableObjectsRequest({
          authorizables: {
            type: ids.type,
            ids: idsBlock
          }
        })
      ),
      GetActionableObjectsForAction.combineResults);
  }

  private static combineResults(results: IGetActionableObjectsResult[]): IGetActionableObjectsResult {
    return {
      ids: ResultHelper.combineIds(results),
      errors: ResultHelper.combineErrors(results)
    };
  }

}

Module.instance().service('GetActionableObjectsForAction', GetActionableObjectsForAction);
